var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"authorinfo"},[_c('div',{staticClass:"authorsummary"},[_c('div',{staticClass:"topbar_first"},[_vm._v("作者")]),_vm._v(" "),_c('router-link',{attrs:{"to":{
      name:'user_info',
      params:{
        id:_vm.userinfo.loginname
      }
    }}},[_c('img',{attrs:{"src":_vm.userinfo.avatar_url}})]),_vm._v(" "),_c('router-link',{attrs:{"to":{
      name:'user_info',
      params:{
        id:_vm.userinfo.loginname
      }
    }}},[_c('span',{staticClass:"loginname"},[_vm._v(_vm._s(_vm.userinfo.loginname))])]),_vm._v(" "),_c('p',{staticClass:"user_profile"},[_vm._v("积分: "+_vm._s(_vm.userinfo.score))])],1),_vm._v(" "),_c('div',{staticClass:"recent_topics"},[_c('div',{staticClass:"topbar"},[_vm._v("作者最近主题")]),_vm._v(" "),_c('div',{staticClass:"inner"},[_c('ul',_vm._l((_vm.topicLimitBy5),function(list){return _c('li',[_c('router-link',{attrs:{"to":{
            name:'post_content',
            params:{
              id:list.id,
              name:list.author.loginname
            }
          }}},[_vm._v("\r\n            "+_vm._s(list.title)+"\r\n          ")])],1)}),0)])]),_vm._v(" "),_c('div',{staticClass:"recent_replies"},[_c('div',{staticClass:"topbar"},[_vm._v("作者最近回复")]),_vm._v(" "),_c('div',{staticClass:"inner"},[_c('ul',_vm._l((_vm.replyLimitBy5),function(list){return _c('li',[_c('router-link',{attrs:{"to":{
            name:'post_content',
            params:{
              id:list.id,
              name:list.author.loginname
            }
          }}},[_vm._v("\r\n            "+_vm._s(list.title)+"\r\n          ")])],1)}),0)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-509ddba6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SlideBar.vue
// module id = null
// module chunks = 